import _isNil from 'lodash/isNil';

import { api } from './apiRequest';
import { getValueFromLocalStorage } from './common';

export type MeasurementParamIcon = {
  id: number;
  name: string;
  icon_url: string;
  reference_id: string;
  image_link: string;
};

let cachedBoutiqueId: string | null = null;
let cachedIcons: MeasurementParamIcon[] | null = null;
let inFlightPromise: Promise<MeasurementParamIcon[]> | null = null;

const mapApiItemToIcon = (item: any): MeasurementParamIcon => {
  const imageUrl: string = item.image_link || item.icon_url || item.image_url || '';

  // Derive a compact reference from the image URL for image_link (e.g. tUs3PJheight)
  const filename = imageUrl.split('/').pop() || '';
  const referenceFromFilename = filename.split('.')[0] || filename;

  return {
    id: Number(item.id),
    name: String(item.display_name || item.name || referenceFromFilename || 'Measurement'),
    icon_url: imageUrl,
    reference_id: referenceFromFilename,
    image_link: referenceFromFilename,
  };
};

export const getMeasurementParamIcons = async (forceRefresh = false) => {
  const boutique_id = getValueFromLocalStorage('boutique_id');

  if (!boutique_id) {
    return [];
  }

  // If boutique changed, invalidate cache
  if (cachedBoutiqueId !== String(boutique_id)) {
    cachedBoutiqueId = String(boutique_id);
    cachedIcons = null;
    inFlightPromise = null;
  }

  if (!forceRefresh && cachedIcons) {
    return cachedIcons;
  }

  if (!forceRefresh && inFlightPromise) {
    return inFlightPromise;
  }

  inFlightPromise = (async () => {
    const response = await api.getRequest(
      `new_measurement/v2/${boutique_id}/measurement_param/icons`
    );

    if (!response.status || _isNil(response.data)) {
      return [];
    }

    const rawData = response.data as any;
    const list: any[] = Array.isArray(rawData)
      ? rawData
      : Array.isArray(rawData.measurement_param_details)
        ? rawData.measurement_param_details
        : [];

    const icons = list.map(mapApiItemToIcon).filter((i) => i.icon_url);
    cachedIcons = icons;

    return icons;
  })();

  try {
    return await inFlightPromise;
  } finally {
    inFlightPromise = null;
  }
};
